/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Btn_CreateInputs */

const en_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

const es_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

const de_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const zh_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

const ar_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء حساب`)
};

const fr_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un compte`)
};

const vi_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo tài khoản`)
};

const sw_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua akaunti`)
};

const th_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างบัญชี`)
};

const bs_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreiraj račun`)
};

const ja_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成`)
};

const ko_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 만들기`)
};

const pt_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar conta`)
};

const it_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea account`)
};

const sv_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa konto`)
};

const nl_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account aanmaken`)
};

const da_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret konto`)
};

const nb_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprett konto`)
};

const fi_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tili`)
};

const pl_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

const ru_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать аккаунт`)
};

const tr_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap oluştur`)
};

const hi_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता बनाएँ`)
};

const id_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat akun`)
};

const ms_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta akaun`)
};

const cs_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit účet`)
};

const el_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δημιουργία λογαριασμού`)
};

const he_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת חשבון`)
};

const af_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skep rekening`)
};

const hu_auth_btn_create = /** @type {(inputs: Auth_Btn_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiók létrehozása`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Auth_Btn_CreateInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_btn_create = /** @type {((inputs?: Auth_Btn_CreateInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Btn_CreateInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_btn_create(inputs)
	if (locale === "de") return de_auth_btn_create(inputs)
	if (locale === "zh") return zh_auth_btn_create(inputs)
	if (locale === "ar") return ar_auth_btn_create(inputs)
	if (locale === "fr") return fr_auth_btn_create(inputs)
	if (locale === "vi") return vi_auth_btn_create(inputs)
	if (locale === "sw") return sw_auth_btn_create(inputs)
	if (locale === "th") return th_auth_btn_create(inputs)
	if (locale === "bs") return bs_auth_btn_create(inputs)
	if (locale === "ja") return ja_auth_btn_create(inputs)
	if (locale === "ko") return ko_auth_btn_create(inputs)
	if (locale === "pt") return pt_auth_btn_create(inputs)
	if (locale === "it") return it_auth_btn_create(inputs)
	if (locale === "sv") return sv_auth_btn_create(inputs)
	if (locale === "nl") return nl_auth_btn_create(inputs)
	if (locale === "da") return da_auth_btn_create(inputs)
	if (locale === "nb") return nb_auth_btn_create(inputs)
	if (locale === "fi") return fi_auth_btn_create(inputs)
	if (locale === "pl") return pl_auth_btn_create(inputs)
	if (locale === "ru") return ru_auth_btn_create(inputs)
	if (locale === "tr") return tr_auth_btn_create(inputs)
	if (locale === "hi") return hi_auth_btn_create(inputs)
	if (locale === "id") return id_auth_btn_create(inputs)
	if (locale === "ms") return ms_auth_btn_create(inputs)
	if (locale === "cs") return cs_auth_btn_create(inputs)
	if (locale === "el") return el_auth_btn_create(inputs)
	if (locale === "he") return he_auth_btn_create(inputs)
	if (locale === "af") return af_auth_btn_create(inputs)
	if (locale === "hu") return hu_auth_btn_create(inputs)
	return en_auth_btn_create(inputs)
});